import Product = FBInstant.Product;
import Purchase = FBInstant.Purchase;

export type ProductId = string;
export type PurchaseToken = string;

export enum PurchaseStatus {
    Error,
    Cancelled,
    Success,
}

export interface IPurchaseResult {
    status: PurchaseStatus;
    purchase?: Purchase;
}

export interface ISDKpayments {
    enabled: boolean;

    getCatalog(): Promise<Product[]>;

    purchase(productID: ProductId): Promise<IPurchaseResult>;

    getPurchases(): Promise<Purchase[]>;

    consumePurchase(purchaseToken: PurchaseToken): Promise<boolean>;
}
